import type { ReactElement } from 'react';

/**
 * EAA-1821: the four glyphs the audit filter bar draws, kept in one file so
 * the chip, the date chip and the bar cannot drift into three slightly
 * different funnels. They carry NO colour of their own (`stroke="currentColor"`)
 * — the active/inactive tint arrives from the CSS class on the element that
 * owns them, which is what keeps the palette in `09b-audit-filters.css` and
 * out of the TSX.
 */

export function SearchIcon({ className }: { className?: string }): ReactElement {
    return (
        <svg
            viewBox="0 0 24 24"
            width="16"
            height="16"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            aria-hidden="true"
            className={className}
        >
            <circle cx="11" cy="11" r="7" />
            <path d="m20 20-3.5-3.5" strokeLinecap="round" />
        </svg>
    );
}

export function FunnelIcon({ className }: { className?: string }): ReactElement {
    return (
        <svg
            viewBox="0 0 24 24"
            width="13"
            height="13"
            fill="none"
            stroke="currentColor"
            strokeWidth={1.8}
            aria-hidden="true"
            className={className}
        >
            <path d="M4 5h16l-6 7.5V18l-4 2v-7.5z" strokeLinejoin="round" />
        </svg>
    );
}

export function ChevronDownIcon({ className }: { className?: string }): ReactElement {
    return (
        <svg
            viewBox="0 0 24 24"
            width="13"
            height="13"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            aria-hidden="true"
            className={className}
        >
            <path d="m6 9 6 6 6-6" strokeLinecap="round" />
        </svg>
    );
}

export function CrossIcon({
    className,
    size = 13,
}: {
    className?: string;
    size?: number;
}): ReactElement {
    return (
        <svg
            viewBox="0 0 24 24"
            width={size}
            height={size}
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            aria-hidden="true"
            className={className}
        >
            <path d="M6 6l12 12M18 6 6 18" strokeLinecap="round" />
        </svg>
    );
}

export function CheckIcon({ className }: { className?: string }): ReactElement {
    return (
        <svg
            viewBox="0 0 24 24"
            width="14"
            height="14"
            fill="none"
            stroke="currentColor"
            strokeWidth={2.4}
            aria-hidden="true"
            className={className}
        >
            <path d="m5 13 4 4L19 7" strokeLinecap="round" />
        </svg>
    );
}
